export const iconFontAwesomeMapsWrench = (
	<i className="fa-solid fa-wrench"></i>
);
